import React, {useContext, useState} from 'react';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router';
import {RoleContext} from "../contexts/RoleContext";
import {LoginContext} from "../contexts/LoginContext";
import { Layout, Menu } from 'antd';
export const logOut = (reg) => {
    window.imbaChat.destroy()
    window.localStorage.clear('comet-token');
    window.localStorage.clear('comet-user-id');
    window.localStorage.clear('cube-token');
    window.localStorage.clear('user_id');
    window.localStorage.clear('token');
    window.localStorage.clear('user_id_a');
    window.localStorage.clear('token_a');
    window.location.href = '#/'+reg+'/signIn';
};

const Header = ({ location }) => {
    var href = location.pathname // Наша псевдоссылка
    var reg = href.replace(/^\/(\d+)\#?.*$/, '$1');
    let authText = localStorage.getItem('comet-token') ? 'Sign Out' : 'Sign In';
    const {getRole} = useContext(RoleContext);
    const {getLogin} = useContext(LoginContext);
    //const [login, setLogin] = useState(localStorage.getItem('imbachat_login'));
    let role = getRole()
    let login = getLogin()
    
  return (
        <>
      <Layout.Header
          className={'imba_header'}
          style={{
              padding: '0 32px',
          }}
      >
          <div
              style={{
                  float: 'left',
              }}
          >
              <h2
                  className={'head_title bolder'}
              >
                  Imba
              </h2>
              <h2
                  className={'head_title'}
              >Chat </h2>
              <h2
                  className={'head_title cursive'}
              >admin panel</h2> 
              &nbsp;Your role {role}
              &nbsp;Login {login}
          </div>
          <div style={{
              float: "right"
          }}>
              <a onClick={()=>logOut(reg)} className={'button'}>{authText}</a>
          </div>
      </Layout.Header>
      </>
  )
};

export default withRouter(Header);
